// Import from NPM
// -------------------------------------
import React from "react";
import { useFeatures } from "flagged";
import { useNavigate } from "react-router-dom";
import { darkStyle } from "@utilities/helpers";

import { Div } from "@components/Generics.react";
import "@styles/courseLayout.scss";

export default function LongLogoBlock(props) {
    const { isolated, user, logo, isSim } = props;
    const features = useFeatures();
    const navigate = useNavigate();
    const isPortrait = window.innerWidth < window.innerHeight;

    // ========================= Render Function =================================
    return (
        <Div
            float-left
            rounded={!isPortrait}
            className={`logo-block ${isSim ? "isSim" : ""}`}
            onClick={() => navigate(isolated ? "#" : "/")}
            // style={darkStyle(user.branding?.colors?.main)} //Hide bg for axis requirement
        >
            <img
                src={
                    features.tenanting.multiTenanted
                        ? user.branding?.image ||
                          `/assets/images/configurable/logo${
                              features.darkMode ? "-inverted" : ""
                          }-full.png`
                        : logo ||
                          `/assets/images/configurable/logo${
                              features.darkMode ? "-inverted" : ""
                          }-full.png`
                }
                alt="Brand Logo"
                className="long-logo"
            />
        </Div>
    );
}
